import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import { SERVICE_ENTITY_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import {
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
const transformJiraServicesToLegacyServices = ({ serviceId, name }) => ({
	id: serviceId,
	name: name ?? undefined,
});

export const transformAggAffectedServicesToLegacyField: FieldTransformer<
	typeof SERVICE_ENTITY_CF_TYPE
> = (node) => {
	if (node.type !== SERVICE_ENTITY_CF_TYPE) {
		return undefined;
	}

	const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
	const value = hasValue
		? transformAggConnection(
				node.selectedAffectedServicesConnection,
				transformJiraServicesToLegacyServices,
			)
		: null;

	return {
		...transformAggNodeToLegacyField(node),
		autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null, // See BENTO-11604
		value,
		schema: {
			configuration: null,
			custom: SERVICE_ENTITY_CF_TYPE,
			items: 'service-entity-field',
			renderer: PLAIN_TEXT,
			system: null,
			type: 'array',
		},
	};
};
